import React from "react";
import { Grid, Typography } from "@mui/material";
import { FormattedMessage } from "react-intl";

import { styles } from "../style";

import GetImages from "@/components/GetImages";
import TruncatedText from "@/components/TruncatedText";

import {
  formatPhoneNumber,
  openClinicMapLocation,
  timeInAmPmFromDateTime,
  transformDateToDDMMYYYY,
} from "@/utils";
import { supportNumber } from "@/utils/Config";

import { IDoctorScheduleConsultationType } from "@/models/doctor";
import { IOrderStatus } from "@/models/ApiRequestResponse/patient";

interface IProps {
  slotNo?: number;
  startTime: string;
  endTime?: string;
  slotDuration: number;
  type: IDoctorScheduleConsultationType;
  clinicName?: string;
  patientDetail: string;
  latitude?: number;
  longitude?: number;
  status: IOrderStatus;
}
const AppointmentDetail: React.FC<IProps> = (props) => {
  const {
    slotNo,
    startTime,
    slotDuration,
    type,
    clinicName,
    endTime,
    patientDetail,
    latitude,
    longitude,
    status,
  } = props;
  return (
    <Grid item>
      <Typography component={"p"} sx={styles.videoTimeDetail}>
        <GetImages name={"SmileOrderIcon"} width="18" height="16" />
        {patientDetail}
      </Typography>
      <Typography component={"p"} sx={styles.videoTimeDetail}>
        <GetImages name={"ScheduleSelectedSmallIcon"} width="18" height="16" />
        {type === IDoctorScheduleConsultationType.IN_CLINIC ? (
          <>
            {transformDateToDDMMYYYY(startTime)},{" "}
            {timeInAmPmFromDateTime(startTime)}-
            {timeInAmPmFromDateTime(endTime!)},{" "}
            <FormattedMessage id="slot_no" defaultMessage="Slot No." /> {slotNo}
          </>
        ) : (
          <>
            {slotDuration} <FormattedMessage id="mins" defaultMessage="Mins" />{" "}
            • {timeInAmPmFromDateTime(startTime)},{" "}
            {transformDateToDDMMYYYY(startTime)}
          </>
        )}
      </Typography>

      {type === IDoctorScheduleConsultationType.VIDEO_CALL ? (
        <>
          <Typography component={"p"} sx={styles.videoTimeDetail}>
            <GetImages name={"VideoAppointmentIcon"} width="18" height="16" />
            <FormattedMessage
              id="video_consultation"
              defaultMessage="Video Consultation"
            />
          </Typography>
          <Typography
            component={"p"}
            sx={{
              ...styles.videoTimeDetail,
              ...styles.hideShowBlock,
              display: "flex",
            }}
          >
            <GetImages name={"TelePhoneIcon"} width="18" height="16" />
            <FormattedMessage
              id="contact_support"
              defaultMessage="Contact Support"
            />{" "}
            - {formatPhoneNumber(supportNumber)}
          </Typography>
        </>
      ) : (
        <>
          <Typography
            component={"p"}
            sx={{
              ...styles.videoTimeDetail,
              ...styles.hideShowBlock,
              display: "flex",
            }}
          >
            <GetImages name={"TelePhoneIcon"} width="18" height="16" />
            <FormattedMessage
              id="contact_support"
              defaultMessage="Contact Support"
            />{" "}
            - {formatPhoneNumber(supportNumber)}
          </Typography>
          <Grid item sx={styles.clinicInfo}>
            <TruncatedText
              text={clinicName}
              muiStyles={styles.videoTimeDetail}
              maxLength={30}
              icon={
                <GetImages name={"ClinicSmallIcon"} width="18" height="16" />
              }
            />
            {status !== IOrderStatus.PENDING && (
              <Grid
                item
                sx={styles.clinicLocation}
                onClick={() =>
                  openClinicMapLocation(latitude ?? 0, longitude ?? 0)
                }
              >
                <GetImages name="HospitalLocationIcon" width="16" height="16" />
                <Typography component={"p"} sx={styles.mapText}>
                  <FormattedMessage id="maps" defaultMessage="Maps" />
                </Typography>
              </Grid>
            )}
          </Grid>
        </>
      )}
    </Grid>
  );
};

export default AppointmentDetail;
